<script setup>
import AllServicesComponent from "@js/components/AllServicesComponent.vue";
import {useCallbackStore} from "@js/store/CallbackStore.js";
import Breadcrumbs from "@js/components/Breadcrumbs/Breadcrumbs.vue";

const callbackStore = useCallbackStore();
</script>

<template>
    <div class="bg-bluish">

        <!-- HERO -->
        <section class="relative overflow-hidden bg-[#050505] text-white">

            <!-- background -->
            <div class="absolute inset-0">
                <div
                    class="h-full w-full bg-[url('@img/backgrounds/pattern-4.webp')] bg-cover bg-center opacity-60"
                ></div>

                <div class="absolute inset-0 bg-black/70"></div>

                <div
                    class="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(255,196,0,0.14),transparent_30%),radial-gradient(circle_at_85%_18%,rgba(255,196,0,0.1),transparent_24%),radial-gradient(circle_at_bottom_right,rgba(255,255,255,0.04),transparent_26%)]"
                ></div>

                <div class="absolute -left-24 top-24 h-[260px] w-[260px] rounded-full bg-baseColor/10 blur-3xl"></div>
                <div
                    class="absolute right-[-80px] top-[-40px] h-[260px] w-[260px] rounded-full bg-baseColor/10 blur-3xl"></div>
            </div>

            <!-- content -->
            <div
                class="relative container flex min-h-[calc(100vh-80px)] flex-col justify-center max-md:pt-[90px] md:min-h-[calc(100vh-92px)]">

                <div class="max-w-3xl">
                    <Breadcrumbs theme="dark"/>
                    <!-- badge -->
                    <div
                        class="mb-3 inline-flex items-center gap-3 rounded-full border border-white/10 bg-white/5 px-4 py-2">
                        <span class="h-2 w-2 rounded-full bg-baseColor shadow-[0_0_18px_rgba(255,196,0,0.8)]"></span>
                        <p class="text-xs font-semibold uppercase tracking-[0.14em] text-white/65">
                            Услуги X-DEVS
                        </p>
                    </div>
                    <!-- title -->
                    <h1 class="text-3xl font-extrabold leading-[1.05] tracking-[-0.04em] md:text-5xl">
                        Комплексные digital-решения
                        <span class="text-baseColor">для бизнеса</span>
                    </h1>

                    <!-- description -->
                    <p class="quote mt-6 text-sm leading-[1.6] text-white/80 md:text-lg">
                        Помогаем выстроить системную работу бизнеса: от привлечения клиентов
                        и маркетинга до автоматизации процессов, внедрения CRM и разработки
                        собственных цифровых решений.
                    </p>

                    <!-- chips -->
                    <div class="mt-8 flex flex-wrap gap-3">
                        <div
                            class="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-2 text-sm text-white/75">
                            <span class="h-1.5 w-1.5 rounded-full bg-baseColor"></span>
                            Разработка и интеграции
                        </div>

                        <div
                            class="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-2 text-sm text-white/75">
                            <span class="h-1.5 w-1.5 rounded-full bg-baseColor"></span>
                            Внедрение CRM
                        </div>

                        <div
                            class="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-2 text-sm text-white/75">
                            <span class="h-1.5 w-1.5 rounded-full bg-baseColor"></span>
                            Продвижение и маркетинг
                        </div>
                    </div>

                    <!-- CTA -->
                    <div class="mt-10 flex flex-col gap-4 sm:flex-row sm:items-center">
                        <div
                            @click.prevent="callbackStore.showBaseCallbackPopup({ title: 'Услуги X-DEVS', description: 'Страница услуг' })"
                            class="inline-flex h-[54px] w-full cursor-pointer items-center justify-center rounded-2xl bg-baseColor px-6 text-[16px] font-bold text-black shadow-[0_12px_40px_rgba(255,196,0,0.22)] transition hover:-translate-y-0.5 hover:bg-[#e6b000] sm:w-auto sm:min-w-[230px]"
                        >
                            Обсудить проект
                        </div>

                        <div class="flex items-center gap-3 text-sm text-white/55">
                            <span class="h-px w-10 bg-white/15"></span>
                            Подберём решение под задачи бизнеса
                        </div>
                    </div>

                </div>
            </div>
        </section>

        <!-- SERVICES -->
        <AllServicesComponent/>

    </div>
</template>
